import { impressum } from '../../../../constants';

export const content = {
    prague: {
        col1: [
            {
                id: 1,
                message: 'contact.prague.hero.address.col1.line1',
            },
        ],
        col2: [
            {
                id: 1,
                message: 'contact.prague.hero.address.col2.line1',
            },
            {
                id: 2,
                message: 'contact.prague.hero.address.col2.line2',
            },
        ],
        col3: [
            {
                id: 1,
                message: 'contact.prague.hero.address.col3.line1',
            },
            {
                id: 2,
                message: 'contact.prague.hero.address.col3.line2',
            },
            {
                id: 3,
                message: 'contact.prague.hero.address.col3.line3',
            },
        ],
        inquiry: {
            message: 'contact.prague.hero.address.inquiry.message',
            cta: 'contact.prague.hero.address.inquiry.cta',
        },
    },
    berlin: {
        col1: [
            {
                id: 1,
                message: 'contact.berlin.hero.address.col1.line1',
            },
            {
                id: 2,
                message: 'contact.berlin.hero.address.col1.line2',
            },
        ],
        col2: [
            {
                id: 1,
                message: 'contact.berlin.hero.address.col2.line1',
            },
            {
                id: 2,
                message: 'contact.berlin.hero.address.col2.line2',
            },
            {
                id: 3,
                message: 'contact.berlin.hero.address.col2.line3',
            },
        ],
        col3: [
            {
                id: 1,
                message: 'contact.berlin.hero.address.col3.line1',
            },
        ],
        inquiry: {
            message: 'contact.berlin.hero.address.inquiry.message',
            cta: 'contact.berlin.hero.address.inquiry.cta',
        },
        impressum,
    },
};
